import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
export enum StateVariant {
  Init = 'init',
  Start = 'start',
  End = 'end'
}
@Injectable({
  providedIn: 'root'
})
export class QstateService {
  state = StateVariant.Init;
  questionNum = 0;
  questions = [];
  constructor(private http: HttpClient) {}
  getQuestions() {
    return this.http.get('assets/questions.json');
  }
}
